export default "__VITE_ASSET__DCpFJjfZ__"